import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    IconButton,
    MenuItem,
    Checkbox,
    FormControlLabel,
    InputAdornment,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import DraggableDialog from '../../../ui/draggableDialog';
import { ValidDataService } from '../../../../service/validDataService';
import { toast } from 'react-toastify';
import { isLocalDev } from '../../../../utils/environment';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { initialValues, validationSchemaValidOrderServices } from '../validDataFormValidationSchema';
import validLookup from '../../../../utils/validLookup';

const validServicesForm = ({
    insert, remove, form
}) => (
    <Form>
        {
            form.values.validServiceData.map((value, index) => (

                <Grid container spacing={2} key={index} sx={{ mt: 1, mb: 1 }}>
                    <Grid item xs={6}>
                        <Field
                            as={TextField}
                            name={`validServiceData[${index}].name`}
                            label="Name"
                            required
                            fullWidth

                        />
                        <ErrorMessage name={`validServiceData[${index}].name`}>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                    </Grid>
                    <Grid item xs={2}>
                        <Field
                            as={TextField}
                            name={`validServiceData[${index}].cost`}
                            label="Cost"
                            required
                            fullWidth
                        />
                        <ErrorMessage name={`validServiceData[${index}].cost`}>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                    </Grid>
                    <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Field
                                    as={Checkbox}
                                    name={`validServiceData[${index}].isTaxable`}
                                    type="checkbox"
                                    checked={form.values.validServiceData[index].isTaxable}
                                />
                            }
                            label="Is Taxable"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Field
                            as={TextField}
                            name={`validServiceData[${index}].defaultTaxPercentage`}
                            label="Tax Percentage"
                            fullWidth
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                        />
                        <ErrorMessage name={`validServiceData[${index}].defaultTaxPercentage`}>{message => <Typography color={'red'}>{message}</Typography>}</ErrorMessage>
                    </Grid>
                    <Grid item xs={3}>
                        <Field
                            as={TextField}
                            name={`validServiceData[${index}].status`}
                            label="Status"
                            fullWidth
                            select
                        >
                            <MenuItem value={"active"}>Active</MenuItem>
                            <MenuItem value={"inactive"}>Inactive</MenuItem>
                        </Field>
                    </Grid>
                    <Grid item xs={1}>
                        <IconButton variant='outlined'
                            color='primary'
                            type="button"
                            onClick={() => insert(form.values.validServiceData.length, {
                                name: '', cost: '', isTaxable: false, defaultTaxPercentage: 0, status: validLookup.validStatus.active
                            })} // insert an empty string at a position
                        >
                            <AddCircleIcon />
                        </IconButton>
                        {form.values.validServiceData.length > 1 && <IconButton
                            type="button"
                            onClick={() => remove(index)} // remove a friend from the list
                        >
                            <ClearIcon />

                        </IconButton>}
                    </Grid>
                </Grid>
            ))}
        {
            form.isSubmitting ? 'Saving...' : <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!form.isValid}
            >
                Create
            </Button>
        }

    </Form>
);

export default function validOrderServiceInputForm({ open, onClose, onRecordAdded }) {

    const handleSubmit = async (values, { resetForm }) => {

        try {
            const response = await ValidDataService.addValidServices({ ...values })
            const { code, message, data } = response
    
            if (code === 0) {
                toast.success(message);
                onClose();
                onRecordAdded(data);
            } else {
                toast.success(message)
            }
        } catch(error) {
            if (isLocalDev) {
                console.log(error)
            }
            onRecordAdded([]);
            toast.error('Failed to add record')
        }
    };

    return (
        <DraggableDialog title={"Add Services"} onClose={onClose} open={open} width={'lg'}>
            <DialogContent>
                <Formik
                    initialValues={{ validServiceData: [initialValues] }}
                    validationSchema={validationSchemaValidOrderServices}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, touched, isValid }) => (

                        <FieldArray
                            name='validServiceData'
                            component={validServicesForm}
                        />
                    )}
                </Formik>
            </DialogContent>
        </DraggableDialog>
    );
};